/* src/app/admin-dashboard/garantiomsetning/garantiomsetning.component.css */
.go-embed {
  margin-top: 0;
}
.go-table th,
.go-table td {
  white-space: nowrap;
}
.go-group-row td {
  background: var(--v2-bg-subtle);
  font-weight: 600;
  color: var(--v2-text-muted);
  padding: 7px 12px;
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.03em;
}
.go-saving {
  opacity: 0.55;
  transition: opacity 150ms;
}
.go-unlinked td:nth-child(2) {
  color: var(--v2-warn-fg);
  font-style: italic;
}
.go-input {
  width: 90px;
  border: 1px solid var(--v2-border-strong);
  border-radius: var(--v2-radius-sm);
  padding: 5px 8px;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  color: var(--v2-text);
  transition: border-color 120ms;
}
.go-input:hover {
  border-color: var(--v2-text-faint);
}
.go-input:focus-visible {
  outline: none;
  border-color: var(--v2-primary);
  box-shadow: 0 0 0 3px var(--v2-primary-tint-bg);
}
.go-input-sm {
  width: 60px;
}
.go-input-note {
  width: 160px;
}
.go-select {
  width: 100px;
  font-size: 13px;
}
.go-computed {
  position: relative;
}
.go-computed {
  font-variant-numeric: tabular-nums;
}
.go-recompute {
  width: 26px;
  height: 26px;
  line-height: 26px;
}
.go-recompute mat-icon {
  font-size: 16px;
  height: 16px;
  width: 16px;
  color: var(--v2-text-muted);
}
.go-spin {
  animation: go-spin 1s linear infinite;
}
@keyframes go-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.go-neg {
  color: var(--v2-text-faint);
}
.go-table td.num,
.go-table th.num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.go-payer {
  white-space: nowrap;
}
.go-payer-chip {
  margin-left: 6px;
  font-size: 11px;
}
.go-input-payer {
  width: 200px;
}
.go-linked-tag {
  color: var(--v2-text-muted);
  font-size: 12px;
}
.go-period-edit {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}
.go-select-sm {
  width: 90px;
}
.go-period-note {
  color: var(--v2-muted, #6b7280);
  font-style: italic;
  white-space: nowrap;
}
/*# sourceMappingURL=garantiomsetning.component.css.map */
